import { Controller } from "@hotwired/stimulus"

export default class ConfigureController extends Controller {
  static targets = [
    "billingSync",
    "syncResultsTable",
    "product",
    "productMappingId",
    "productMappingName"
  ]

  connect() {
    this.productTargets.map(productTarget => {
      const product = productTarget.dataset.product
      const idInput = this.productMappingIdTargets.find(idTarget => idTarget.dataset.product === product)
      $(idInput).on("select2:select select2:unselecting", this.handleProductNameChange.bind(this, product))
    })

    if (this.hasBillingSyncTarget) {
      $(this.billingSyncTarget).select2({
        theme: "bootstrap",
        allowClear: false,
        width: "100%"
      })
    }

    $(this.syncResultsTableTarget).DataTable()
  }

  handleProductNameChange(product, event) {
    let nameTarget = this.productMappingNameTargets.find(nameTarget => nameTarget.dataset.product === product)
    nameTarget.value = event.target.selectedOptions[0].textContent
  }
}
